export { default } from './Iframe';
